<boi-contextual-help-container [ngClass]="{'has-errors': hasError}"
    [contextualHelpName]="contextualHelpName !== undefined ? contextualHelpName : labelName">
    <boi-validation-error (errorChange)="hasError=$event" [propertyNames]="propertyNames"></boi-validation-error>
    <div class="form-element app k-textbox-container">
        <div class="form-label app" [boiRequiredFormField]="labelName">
            <label [innerHtml]="labelName |
                        localizeLabel"></label>
        </div>
        <div class="form-input-container">
            <boi-date-input [isDisabled]="isFieldDisabled" [(date)]="value" (dateChange)="valueChange.emit(value)">
            </boi-date-input>
        </div>

        <boi-tooltip [tooltipName]="tooltipName ? tooltipName : labelName"></boi-tooltip>

    </div>
</boi-contextual-help-container>